import { Box, AlertTitle, Typography } from '@mui/material';
import { ToastContentProps } from 'react-toastify';
import SVButton from './SVButton';
import { SVToastData } from '@/types/common';

export default function SVToast({
  closeToast,
  data,
}: ToastContentProps<SVToastData>) {
  const { title, content, buttons } = data;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}>
      <Box>
        {title && <AlertTitle sx={{ maxWidth: '95%' }}>{title}</AlertTitle>}
        <Typography variant="body1">{content}</Typography>
      </Box>
      {buttons && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            gap: 2,
            mt: 1,
          }}>
          {buttons.map(button => {
            const { text, variant, onClick, closesToast } = button;

            return (
              <SVButton
                key={text}
                variant={variant}
                onClick={closesToast ? closeToast : onClick}>
                {text}
              </SVButton>
            );
          })}
        </Box>
      )}
    </Box>
  );
}
